export const roles = Object.freeze({
  MOBILE_USER: 0,
  MEMBER: 1,
  WAIT_STAFF: 2,
  SUPERVISOR: 4,
  RESTAURANT_MANAGER: 8,
  ADMIN: 16,
  SYSTEM: 32,
});

export function hasRole(existingRoles, role) {
  return existingRoles & role;
}

// "At or above" gate for Menu.minRole. must be a single role value (not an OR).
export function meetsMinRole(userRoles, minRole) {
  return (userRoles || 0) >= (minRole || 0);
}

export function addRole(existingRoles, role) {
  return existingRoles | role;
}

export function removeRole(existingRoles, role) {
  return existingRoles - role;
}

export const friendlyRoles = Object.freeze([
  { key: "SYSTEM", name: "System" },
  { key: "ADMIN", name: "Admin" },
  { key: "RESTAURANT_MANAGER", name: "Manager" },
  { key: "SUPERVISOR", name: "Supervisor" },
  { key: "WAIT_STAFF", name: "Station" },
  { key: "MEMBER", name: "Member" },
  { key: "MOBILE_USER", name: "Customer" },
]);

export interface RootUserClaims {
  roles?: number;
  name?: string;
  email?: string;
  grants?: { [appCode: string]: number };
  activeRestaurant?: string;
  restaurantIds?: string[];
}

export const buildRootUserClaims = (claims: any): RootUserClaims => ({
  roles: claims?.roles,
  name: claims?.name,
  email: claims?.email,
  grants: claims?.grants,
  activeRestaurant: claims?.activeRestaurant,
  restaurantIds: claims?.restaurantIds,
});

export const decodeRoleLabel = (rolesBitmask: number | undefined): string => {
  if (typeof rolesBitmask !== "number") return "Member";
  for (const r of friendlyRoles) {
    const mask = (roles as Record<string, number>)[r.key];
    if (hasRole(rolesBitmask, mask)) return r.name;
  }
  return "Member";
};
